/**
 * 用户信息
 * */
export default {
  namespaced: true,
  state: {
    // 用户信息
    isErrorDisplay: false
  },
  mutations: {
    setErrorDisplay(state, val) {
      state.isErrorDisplay = val;
    }

  }
};